import * as api from "./middleware/api.middleware";
import { getAuthHeader } from "./auth/authHeaders";

const serviceUrl = "role";
const getAccessToken = () => getAuthHeader();

export function getRoles() {
  const getResponse = api.get<any[]>(`${serviceUrl}`, getAccessToken());
  return getResponse;
}
